export default __webpack_public_path__ + "static/media/2055.2490b441.png";